<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/YF5NuZ/tc-custom/9781455609529.jpg?1705213517674" alt="This image is the cover for the book New Orleans in the Sixties"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">New Orleans in the Sixties
      </h1>
      <p class="bookDescription body article font2">
        <p>In this, her fifth book in the series describing past decades in New Orleans' history, local author and historian Mary Lou Widmer offers readers unique glimpses into the turbulent and triumphal 1960s. </p><p>The decade of the sixties was one that confounded America like no period before. It ushered in a time of social change and tension. In New Orleans, this period was visible in the city's skyline as the face of New Orleans began to change. Tourism became a major concern, construction on the Superdome began, some of the biggest buildings were built, and the Saints came marching in.</p><p>Packed with photographs and reminiscences of an important decade in the evolution of this American metropolis, New Orleans in the Sixties is a unique accomplishment that will interest both residents and lovers of the Crescent City.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mary Lou Widmer
      </h2>
      
      <p class="authorDescription body article">MARY LOU WIDMER, a native of New Orleans, is a certified descendant of the area's settlers prior to the Louisiana Purchase. She is a member of the Louisiana Colonials and the Daughters of 1812.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pelican Publishing Company
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?b4797712